module.exports = __webpack_public_path__ + "img/bg_solution01.030be92f.png";